<div class="lp-collection-new">
  <lp-collection-new-header
    class="lp-collection-new__header"
    [city]="currentCity"
    (cityChange)="refresh($event)"
  ></lp-collection-new-header>

  <div class="lp-collection-new__content">
    <tui-scrollbar class="products-list">
      <div class="products-list__header">
        <lp-category-header
          [title]="'components.lpCollectionNew.labels.title' | translate"
          (back)="onClickBackButton()"
        ></lp-category-header>

        <app-list-mode-switcher
          class="mode-switcher"
          [(mode)]="productListMode"
          [storageKey]="listModeStorageKey"
        ></app-list-mode-switcher>
      </div>

      <ng-container *ngIf="products; else loaderTmp">
        <ng-container *ngIf="products.length; else noDataTmp">
          <lp-products-list
            [products]="products"
            [productListMode]="productListMode"
            [showIsFavorite]="true"
          ></lp-products-list>
        </ng-container>
      </ng-container>
    </tui-scrollbar>
  </div>
</div>

<ng-template #loaderTmp>
  <app-loader-wrapper [loading]="true"></app-loader-wrapper>
</ng-template>

<ng-template #noDataTmp>
  <lp-no-data-found></lp-no-data-found>
</ng-template>
